module.exports = __webpack_public_path__ + "static/img/ios.2e3bdf3d.png";